import React, { useEffect, useRef, useState } from 'react';
import {Button, Box, Typography, Grid } from "@mui/material";
import VerificationFrequenciesTable from "../components/analytics/verification-frequencies-table.component";
import MostVerifiedProductsDonutChart from "../components/analytics/most-verified-products-donut-chart.component";
import ProductComparativeAnalysis from "../components/analytics/product-comparative-analysis.component";
import PeakVerificationTimeAnalysis from "../components/analytics/peak-verification-time-analysis.component";
import KeyMetricsStats from "../components/analytics/key-metrics-stats.component";
import MapAnalytics from '../components/analytics/map.component';
import OfflineIcon from "../assets/images/offline.png";

const AnalyticsScreen = () => {

    const parentRef = useRef(null);
    const [parentHeight, setParentHeight] = useState(0);

    const [isOnline, setOnline] = useState(navigator.onLine);


    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);
    
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    },  []);

    useEffect(() => {
        if (parentRef.current) {
            // setParentHeight(parentRef.current.clientHeight);
            // readjust height. reduce to x percent
            var num1 = parentRef.current.clientHeight;
            var percent = 10.9; // percentage decrease
            var num2 = num1 / (1 + (percent / 100));
            setParentHeight(num2);
        }
    }, []);


    return (

        <Box>
            <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20, mb: 3}}>
                Analytics
            </Typography>

            {(isOnline) ? 
                <>
                    <KeyMetricsStats />
                    <br/>

                    <Grid ref={parentRef} container spacing={2}>
                        <Grid item xs={6}>
                            <VerificationFrequenciesTable/>
                            <br/>
                            <MostVerifiedProductsDonutChart/>
                        </Grid>
                        <Grid item xs={6}>
                            {parentHeight != 0 && <MapAnalytics parentHeight={parentHeight} />}
                        </Grid>
                    </Grid>
                    <br/>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <PeakVerificationTimeAnalysis/>
                        </Grid>

                        <Grid item xs={6}>
                            <ProductComparativeAnalysis/>
                        </Grid>
                    </Grid>
                </>
            :
                <Box sx={{textAlign: 'center', mt: 20}}>  
                    <img alt="" src={OfflineIcon} style={{height: 80, marginBottom: "16px"}} />

                    <Typography sx={{fontSize: 20, fontWeight: "bold", mb: 0.5, color: "#58565f"}}>
                        Ooops!
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Failed to load data.
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Please check your internet connection or try again.
                    </Typography>

                    <Button variant="contained" sx={{mt: 2.5, bgcolor: '#3333cf', textTransform:'none'}} onClick={() => window.location.reload()}>
                        Try again
                    </Button>
                </Box>
            }
        </Box>
    )
}

export default AnalyticsScreen;